"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzHeader = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

require("./SzHeader.scss");

function SzHeader(_a) {
  var children = _a.children,
      bg = _a.bg,
      className = _a.className;
  var headerClasses = classnames_1.default('sz-header', className, {
    'bg-white text-primary': bg === 'light',
    'bg-secondary text-white': bg === 'dark'
  });
  return react_1.default.createElement("div", {
    className: headerClasses
  }, children);
}

exports.SzHeader = SzHeader;
SzHeader.defaultProps = {
  bg: 'light'
};
exports.default = SzHeader;